/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForSecureScoresConfiguration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForSecureScoresConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForSecureScoresConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForSecureScoresConfiguration>): BackgroundJobPayloadForSecureScoresConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForSecureScoresConfiguration(), model);
        BackgroundJobPayloadForSecureScoresConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForSecureScoresConfiguration>): BackgroundJobPayloadForSecureScoresConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForSecureScoresConfiguration.newInstance(<BackgroundJobPayloadForSecureScoresConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForSecureScoresConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForSecureScoresConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForSecureScoresConfiguration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForSecureScoresConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
